import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
`

export const Content = styled.div`
  width: calc(100% - 176px);
  height: fit-content;
  margin-left: 176px;
  padding: 72px 0 100px;
  position: relative;

  button {
    cursor: pointer;
  }

  .services__wrapper {
    width: 95%;
    margin: 0 auto;

    display: flex;
    flex-direction: column;

    gap: 2.5rem;

    > * {
      margin-left: 2rem;
    }
  }

  .services__title {
    margin-top: 17px;

    color: var(--blue00);
    font-size: 1.625rem;
    font-weight: bold;
  }

  .services__information-container {
    background-color: var(--bluef0);

    max-width: 50rem;

    padding: 2rem;

    border-radius: 1.125rem;
    margin-left: 0;

    line-height: 1.15;
  }

  .services__subtitle {
    color: var(--blue00);
    font-size: 1.25rem;
    font-weight: 400;
  }

  .services__text {
    color: var(--grayad);
    font-size: 1.25rem;
    font-weight: 300;
    margin-top: 0.75rem;
  }

  .services__price-table-wrapper {

    border-radius: 2rem;

    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

    width: fit-content;

    overflow: hidden;

    table {
      color: var(--blue00);
    }

    thead tr th {
      color: var(--blue00);

      font-size: 1.625rem;
      font-weight: bold;

      padding: 2rem;

      min-height: 5.9375rem;

      vertical-align: middle;
      text-align: center;
      border-bottom: 1px solid #0078D725;
    }

    tbody tr td {
      border-bottom: 1px solid #0078D725;
      padding: 1rem 2rem;

      &:last-child {
        border-left: 1px solid #0078D725;
      }
    }

    tfoot tr td {
      height: 3rem;
    }
  }

  .services__table-question-button {
    margin-left: 0.25rem;
    position: relative;

    &::before {
      content: attr(data-tooltip);
      font-size: 0.75rem;
      font-family: 'Axiforma', sans-serif;

      width: 10rem;

      transition: opacity 0.25s, visibility 0.5s;

      position: absolute;
      right: -1rem;
      top: 0rem;
      transform: translateX(90%);

      overflow: visible;

      padding: 0.4rem;
      border-radius: 0.25rem;

      background-color: #fff;

      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

      visibility: hidden;
      opacity: 0;

      color: #25273195;
    }

    &:hover::before {
      visibility: visible;
      opacity: 1;
    };
  }

  .services__select-category-container {
    h2 {
      font-size: 1.5rem;
      font-weight: bold;
      color: var(--blue00);
      margin-bottom: 1rem;
    }
  }

  .services__select{
    width: 95%;
    max-width: 324px;

    box-shadow: 0 3px 6px rgba(0,0, 0, 0.19);
  }

  .services__table-question-button {
    background: transparent;
    border: none;
  }

  .services__table-edit-button {
    background: transparent;
    border: none;
  }

  .services__table-second-col-container {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-end;
    gap: 0.5rem;
  }

  .services__input-wrapper {
    width: 100%;
  }

  .services__label {
    display: block;

    width: 100%;

    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 1rem;
    color: var(--blue00);
  }

  .services__prefix-input-container {
    height: 55px;
    margin-top: 7.4px;
    padding: 0 23.7px;

    width: 100%;

    max-width: 324px;

    color: var(--blue00);
    font-size: 1rem;
    border: 0;
    outline: none;
    border-radius: 25px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.19);

    display: flex;
    align-items: center;

    &:focus-within {
      outline: 2px solid var(--grayad);
    }
  }

  .services__prefix {
    font-size: 1rem;
    font-weight: 400;

    color: var(--blue00);
  }

  .services__prefix-input {
    background: transparent;
    border: none;
    outline: none;

    margin-left: 0.25rem;

    font-size: 1rem;
    font-weight: 400;
    flex: 1;

    color: var(--blue00);
  }

  @media (max-width: 1170px){
    width: 95%;
    margin: 0 auto;
  }
`

export const ReturnButton = styled(Link)`
  position: absolute;
  top: 29px;
  left: 32px;

  .services__content-icon{
    height: 20px;
    width: auto;
    stroke: #000;
  }
`
